module.exports = __webpack_public_path__ + "img/government_drr.95a8505c.svg";